import Vue from 'vue';
import VueRouter from 'vue-router';
import verifyPassword from "@/views/backSystem/Others/Password/verifyPassword";
import { perfix } from '../../utils/common.js'
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/index',
  },
  // {
  //     path: '/home',
  //     name: 'home',
  //     component: () => import('./../home'),
  // },
  //首页
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/' + perfix() + 'homePage/index'),
  },
  // 展商
  {
    path: '/exhibition',
    name: 'exhibition',
    component: () => import('../views/' + perfix() + 'exhibition/index'),
  },
  //展商详情
  {
    path: '/exhibition_det',
    name: 'exhibition_det',
    component: () => import('../views/' + perfix() + 'exhibition/exhibition_detail.vue'),
  },

  //直播
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/' + perfix() + 'Live/index'),
  },
  //直播详情
  {
    path: '/live_detail',
    name: 'live_detail',
    component: () => import('../views/' + perfix() + 'Live/Live_detail.vue'),
  },
  //活动
  {
    path: '/active',
    name: 'active',
    component: () => import('../views/' + perfix() + 'active/active'),
  },
  //活动详情
  {
    path: '/active_detail',
    name: 'active_detail',
    component: () => import('../views/' + perfix() + 'active/active_detail.vue'),
  },
  //新闻详情
  {
    path: '/news_detail',
    name: 'news_detail',
    component: () => import('../views/' + perfix() + 'exhibition/news_detail.vue'),
  },
  //展品列表
  {
    path: '/exhibitsList',
    name: 'exhibitsList',
    component: () => import('../views/' + perfix() + 'exhibitsItem/exhibitsList.vue'),
  },
  //展品详情页面
  {
    path: '/exhibItem_detail',
    name: 'exhibItem_detail',
    component: () => import('../views/' + perfix() + 'exhibitsItem/exhibitsItem_detail.vue'),
  },

  //倒计时组件
  {
    path: '/endTime',
    name: 'endTime',
    component: () => import('../EndTime.vue'),
  },
 //快捷方式组件
  {
    path: '/quickly',
    name: 'quickly',
    component: () => import('../Quick.vue'),
  },

  //---------------------------------------展商后台----------------------------------------
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('../views/backSystem/login.vue'),
  },
  {
    path: '/backIndex',
    name: 'backIndex',
    component: () => import('../views/backSystem/index.vue'),
    redirect: '/backIndex/homeIndex',
    children: [
      {
        //apply  特殊申报
        path: '/backIndex/apply',
        name: 'apply',
        component: () => import('../views/backSystem/exhibiService/specalApply/apply.vue'),
      },
      {
        //declare  家具绿植
        path: '/backIndex/greenPlant',
        name: 'greenPlant',
        component: () => import('../views/backSystem/exhibiService/greenPlant/plant.vue'),
      },
      {
        //标摊门楣
        path: '/backIndex/lintel',
        name: 'lintel',
        component: () => import('../views/backSystem/exhibiService/lintel/lintel.vue'),
      },
      {
        //会刊信息
        path: '/backIndex/catalogue',
        name: 'catalogue',
        component: () => import('../views/backSystem/exhibiService/catalogue/catalogue.vue'),
      },
      {
        //会刊信息
        path: '/backIndex/card',
        name: 'card',
        component: () => import('../views/backSystem/exhibiService/exhibitorsCard/card.vue'),
      },

      {
        //易展厅的首页
        path: '/backIndex/homeIndex',
        name: 'homeIndex',
        component: () => import('../views/backSystem/Yihall/homeIndex.vue'),
      },
      {
        //展商信息
        path: '/backIndex/exhiIndex',
        name: 'exhiIndex',
        component: () => import('../views/backSystem/Yihall/exhiInformat/exhiIndex.vue'),
      },
      {
        //产品中心首页
        path: '/backIndex/productIndex',
        name: 'productIndex',
        component: () => import('../views/backSystem/Yihall/product/productIndex.vue'),
      },
      {
        //新增产品
        path: '/backIndex/addproduct',
        name: 'addproduct',
        component: () => import('../views/backSystem/Yihall/product/addProduct.vue'),
      },
      {
        //编辑产品页面
        path: '/backIndex/editproduct',
        name: 'editproduct',
        component: () => import('../views/backSystem/Yihall/product/editProduct.vue'),
      },
      {
        path: '/backIndex/addExhiLive',
        name: 'addExhiLive',
        component: () => import('../views/backSystem/Yihall/exhi_live/addexhiLive.vue'),
      },
      {
        //展商直播页面
        path: '/backIndex/exhiLive',
        name: 'exhiLive',
        component: () => import('../views/backSystem/Yihall/exhi_live/exhiLive.vue'),
      },
      {
        //展商新闻
        path: '/backIndex/exhi_news',
        name: 'exhi_news',
        component: () => import('../views/backSystem/Yihall/exhi_news/exhi_news.vue'),
      },
      {
        //新增新闻
        path: '/backIndex/add_news',
        name: 'exhi_news',
        component: () => import('../views/backSystem/Yihall/exhi_news/add_news.vue'),
      },
      {
        //宣传资料下载页面
        path: '/backIndex/dataIndex',
        name: 'dataIndex',
        component: () => import('../views/backSystem/Yihall/dataDownd/dataIndex.vue'),
      },
      {
        //资料上传页面
        path: '/backIndex/uploadData',
        name: 'uploadData',
        component: () => import('../views/backSystem/Yihall/dataDownd/uploadData.vue'),
      },
      {
        //我的信息
        path: '/backIndex/mineMessage',
        name: 'mineMessage',
        component: () => import('../views/backSystem/Yihall/myMessage/minMessage.vue'),
      },

      {
        //下载中心
        path: '/backIndex/Download',
        name: 'Download',
        component: () => import('../views/backSystem/Others/Download'),
      },
      {
        //原密码
        name: 'verifyPassword',
        path: '/backIndex/verifyPassword',
        component: () => import('../views/backSystem/Others/Password/verifyPassword'),
      },
      {
        //新密码
        name: 'editPassword',
        path: '/backIndex/editPassword',
        component: () => import('../views/backSystem/Others/Password/editPassword'),
      },
      {
        //联系我们
        name: 'Connection',
        path: '/backIndex/Connection',
        component: () => import('../views/backSystem/Others/Connection'),
      },
      {
        //微信邀请
        name: 'wxInvite',
        path: '/backIndex/wxInvite',
        component: () => import('../views/backSystem/inviteAudience/wxInvite'),
      },
      {
        //pdf邀请
        name: 'pdfInvite',
        path: '/backIndex/pdfInvite',
        component: () => import('../views/backSystem/inviteAudience/pdfInvite'),
      },
      {
        //团体邀请
        name: 'groupInvite',
        path: '/backIndex/groupInvite',
        component: () => import('../views/backSystem/inviteAudience/groupInvite'),
      },
      {
        //邮件邀请
        name: 'emailInvite',
        path: '/backIndex/emailInvite',
        component: () => import('../views/backSystem/inviteAudience/emailInvite'),
      },
    ],
  },

  //---------------------------------------观众预登记----------------------------------------
  {
    //预登记第一步
    path: '/wxRegister',
    name: 'wxRegister',
    component: () => import('../views/backSystem/wxRegister'),
  },
  {
    //填写问卷
    path: '/wxQuestionnaire',
    name: 'wxQuestionnaire',
    component: () => import('../views/backSystem/wxRegister/wxQuestionnaire'),
  },
  {
    //成功
    path: '/wxsuccessed',
    name: 'wxsuccessed',
    component: () => import('../views/backSystem/wxRegister/successed'),
  },
];
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
});

export default router;
